import { useState } from "react";
import { withAppHOC, withAccountHOC } from "../../hoc";
import {
  Button,
  Fieldset,
  Form,
  Label,
  MessageBox,
  PasswordInput,
} from "../../components/FormElements";
import Loader from "../../components/Loader/Loader";
import { StyledFormContainer } from "../../components/Styled";
import API from "../../api";
import { RESPONSE_STATUSES } from "../../constants";

const ChangePassword = () => {
  const [state, setState] = useState({
    isLoading: false,
    apiResponseStatus: "",
    apiResponseMessage: "",
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const setStateData = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const updatePassword = async (e) => {
    try {
      e?.preventDefault();
      setStateData("isLoading", true);
      const response = await API.post("/authentication/change-password", {
        oldPassword: state.oldPassword,
        newPassword: state.newPassword,
        confirmNewPassword: state.confirmNewPassword,
      });
      const { status, message, data } = response?.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setStateData("oldPassword", "");
        setStateData("newPassword", "");
        setStateData("confirmNewPassword", "");
        setTimeout(() => {
          setStateData("apiResponseStatus", "");
          setStateData("apiResponseMessage", "");
        }, 3000);
      }
      setStateData("apiResponseStatus", RESPONSE_STATUSES.FAILED);
      setStateData("apiResponseMessage", message);
    } catch (error) {
      console.error(error);
      setStateData("apiResponseStatus", RESPONSE_STATUSES.FAILED);
      setStateData("apiResponseMessage", error.message);
    } finally {
      setStateData("isLoading", false);
    }
  };

  return (
    <>
      <Loader isLoading={state.isLoading} />
      <StyledFormContainer>
        <Form action="#" method="POST" onSubmit={updatePassword}>
          <Fieldset>
            <Label required>Old Password</Label>
            <PasswordInput
              value={state.oldPassword}
              onChange={(value) => setStateData("oldPassword", value)}
              placeholder="Old Password"
              disabled={state.isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>New Password</Label>
            <PasswordInput
              value={state.newPassword}
              onChange={(value) => setStateData("newPassword", value)}
              placeholder="New Password"
              disabled={state.isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>Confirm New Password</Label>
            <PasswordInput
              value={state.confirmNewPassword}
              onChange={(value) => setStateData("confirmNewPassword", value)}
              placeholder="Confirm New Password"
              disabled={state.isLoading}
            />
          </Fieldset>
          {state.apiResponseStatus && state.apiResponseMessage && (
            <Fieldset>
              <MessageBox
                status={state.apiResponseStatus}
                message={state.apiResponseMessage}
              />
            </Fieldset>
          )}
          <Fieldset>
            <Button disabled={state.isLoading}>Save</Button>
          </Fieldset>
        </Form>
      </StyledFormContainer>
    </>
  );
};

export default withAppHOC(
  withAccountHOC(ChangePassword, { title: "Change Password" })
);
